const t = "https://static.xometry.eu/public/hoops/monolithic_2024_6_0.js";
export {
  t as HOOPS_LIB_URL
};
//# sourceMappingURL=HoopsViewerLoader.consts.mjs.map
